module.exports = __webpack_public_path__ + "img/1506729151.96573138.jpg";